/**
 * "EF", set rather than drawn.
 *
 * The platform's mark, not a Brand's. Outscore's ring-o wordmark belongs to Outscore alone
 * (platform/brand.md, "Outscore's identity"), and the Admin Site spans every Brand, so wearing it
 * here would say something untrue about what this tool is. The brand documents specify no mark
 * for Exam Foundation itself, so this is the design system's own heading face and its own green
 * and nothing else invented beside them -- a drawn mark can replace it later without the word
 * changing, exactly as Outscore's ring is allowed to.
 *
 * Naming the platform is fine here and only here: the rule is that no *user* surface hints that
 * more than one Exam or Brand exists (platform:R10). This one is staff-only, behind an app role.
 *
 * Abbreviated to EF: the full name is long, the masthead is not
 * wide, and everyone who sees this screen already knows what it stands for. That is the whole
 * argument for an abbreviation, and it holds only because the audience is four people with an app
 * role -- it would not hold on anything a Student can reach.
 */
export function Wordmark() {
  return (
    <span className="font-heading font-bold text-heading">
      E<span className="text-green-700">F</span>
    </span>
  )
}
